
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const SearchIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 15 14" fill="none" >
            <path d="M5.60547 1C8.13914 1 10.2119 3.07948 10.2119 5.66699C10.2117 8.25435 8.13903 10.333 5.60547 10.333C3.07213 10.3327 1.00017 8.25419 1 5.66699C1 3.07964 3.07202 1.00026 5.60547 1Z" fill="transparent" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <line x1="9.41397" y1="8.9736" x2="13.1639" y2="12.586" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
  )
}
